module.exports = __webpack_public_path__ + "static/media/TheDoctorAward-1.a55ea2fe.png";